import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import TextField from '@material-ui/core/TextField';
import Radio from '@material-ui/core/Radio';
import Typography from '@material-ui/core/Typography';
import InputLabel from '@material-ui/core/InputLabel';
import { FormControl, FormControlLabel, Grid, InputAdornment, RadioGroup, withStyles, WithStyles } from '@material-ui/core';
import { MyPATDialog, MyPATLink, MyPATTextField } from '../../../../common';

import { styles } from './style';
import { MyPATMultiSearch, MyPATSelect } from '../../../../common';
import _ from 'lodash';
import * as courseManagementActions from '../../../actions';
import { courseStyles } from '../../../styles';
import { ExistingScheduledTest } from '../../../types/interfaces/ExistingScheduledTest';
import TimeInput from 'material-ui-time-picker';
import MyPATCalendar from '../../../../common/MyPATCalendar';
import { onlyAllowNumbers } from '../../../../../utils';
import contentService from '../../../../mylibrary/services/contentService';
import courseManagementServices from '../../../service/courseManagementServices';
import { checkIfTestIdAlreadyMappedInPlan } from './helpers/checkAddedTest';
interface AddTestDialogState {
  open: boolean;
  existingTest: boolean;
  scheduledTest: boolean;
  formErrors: any;
  check: boolean;
  scheduledTests: ExistingScheduledTest[];
  scheduledTestsNames: { displayName: string; id: string }[];
  selectedTest: any;
  isTestMapped: boolean;
  mapTestSuggestions: any[];
  mapTestSuggestionNames: any[];
  coursesByScheduleId: any[];
  preparedCourseData: any[];
  isCTADisabled: boolean;
  editMode: boolean;
  mappedTestName: string;
  goalsDriller: any;
}

interface AddTestDialogProps extends WithStyles<typeof styles> {
  title: String;
  classNames: any;
  dropDownStringArray: any;
  textFieldStringArray: any;
  dialogButtonName: String;
  isExistingTest: boolean;
  durationAttemptRevision: any;
  buttonName: String;
  isRequiredMapTest: boolean;
  isExistingAndScheduledTest: boolean;
  isRequiredDate: boolean;
  courseId: string;
  fetchExistingScheduledTests: Function;
  existingScheduledTests: ExistingScheduledTest[];
  mapTestSuggestions: any[];
  fetchMapTestSuggestions: Function;
  courseDetails: any;
  fetchCoursesByScheduleId: Function;
  coursesByScheduleId: any[];
  handleAddTest?: (data: any) => void;
  test: any;
  editMode: boolean;
  open: boolean;
  handleToggleOpen: Function;
  treeData: any;
  isPreview: boolean;
  fetchScheduleTests: Function;
  packageByIdData: any;
  courseName: string;
  phases: any;
  phase: any;
  phaseIndex: number;
  packageStartDate: string;
  packageEndDate: string;
  mappedTest: string;
  testType: string;
  isExtraTests: boolean;
  testDurationFromAPI: number;
  questionsCountFromAPI: number;
}

interface Syllabus {
  text: string;
}

interface PaperDetail {
  syllabus: Syllabus;
  id: string;
  name: string;
  type: string;
}
interface AddTestFormErrors {
  paperDetail: PaperDetail;
  testType: string;
  duration: string;
  status: string;
  codeName: string;
  displayName: string;
  scheduleID: string;
  scheduleDate: string;
  startTime: string;
  scheduleEndDate: string;
  endTime: string;
  maxAttempt: string;
  blockRevisionTime: string;
}

let updatedIsTestMapped;
class AddTestDialogPopUp extends React.Component<AddTestDialogProps, AddTestDialogState> {
   zero24='000000000000000000000000';
  constructor(props: AddTestDialogProps) {
    super(props);
    this.state = {
      open: false,
      existingTest: false,
      scheduledTest: true,
      check: true,
      isCTADisabled: true,
      scheduledTests: [],
      scheduledTestsNames: [],
      selectedTest: {
        paperDetail: {
          syllabus: {
            text: '',
          },
          id: '',
          name: '',
          type: '',
        },
        testType: '',
        duration: '',
        status: '',
        codeName: '',
        displayName: '',
        scheduleID: '',
        scheduleDate: '',
        startTime: '',
        scheduleEndDate: '',
        endTime: '',
        maxAttempt: '',
        questionsCount: 0,
        blockRevisionTime: '',
        id: '',
        mappedTestName: this.props.mappedTest || ''
      },
      formErrors: {
        paperDetail: {
          syllabus: {
            text: '',
          },
          id: '',
          name: '',
          type: '',
        },
        testType: '',
        duration: '',
        status: '',
        codeName: '',
        displayName: '',
        scheduleID: '',
        scheduleDate: this.props.editMode ? '' : 'Start date is required.',
        startTime: '',
        scheduleEndDate: this.props.editMode ? '' : 'End date is required.',
        endTime: '',
        maxAttempt: '',
        questionsCount: '',
        blockRevisionTime: '',
        mappedTestValid: ''
      },
      isTestMapped: false,
      mapTestSuggestions: [],
      mapTestSuggestionNames: [],
      coursesByScheduleId: [],
      preparedCourseData: [],
      editMode: false,
      mappedTestName: '',
      goalsDriller: {}
    };
  }

  componentDidMount() {
    const { courseId } = this.props;
    this.setGoalsDriller(courseId);
    const param = {
      itemType: 'scheduledTests',
      id: this.props.packageByIdData.packageData.courseDetails[0].courseId,
      testType: 'phase'
    };
    this.props.fetchScheduleTests(param);
    if (this.props.editMode) {
      this.setFormData(this.props.test)
    }
  }

  setFormData = (data: any) => {
    const { mappedTest, testDurationFromAPI, questionsCountFromAPI } = this.props;
    let updatedSelectedTest = { ...this.state.selectedTest };

    updatedIsTestMapped = (data.testId !== this.zero24) || 
    (this.props.mappedTest !== '' && this.props.mappedTest !== this.zero24) ? 
    true : false;

    let updatedPaperDetails = {...updatedSelectedTest.paperDetail}
    updatedPaperDetails = {
      syllabus: {
        text: data.syllabus,
      },
      id: data._id || data.testId,
      name: data.displayName,
      type: data.type,
    };
    updatedSelectedTest.paperDetail = updatedPaperDetails;
    updatedSelectedTest.courseId = data.courseId;
    updatedSelectedTest.duration = updatedIsTestMapped ? testDurationFromAPI : data.duration;
    if(data.endDate !== 'Invalid Date') {
      updatedSelectedTest.scheduleEndDate = data.endDate;
    }
    updatedSelectedTest.maxAttempt = data.maxAttempts;
    
    updatedSelectedTest.questionsCount = updatedIsTestMapped ? questionsCountFromAPI : +(data.questionsCount||0);
    updatedSelectedTest.displayName = data.name || data.displayName;
    updatedSelectedTest.blockRevisionTime = data.revisionTime;
    updatedSelectedTest.scheduleDate = data.startDate;
    updatedSelectedTest.testType = data.type;
    updatedSelectedTest.startTime = data.startDate;
    if(data.endDate !== 'Invalid Date') {
      updatedSelectedTest.endTime = data.endDate;
    }
    updatedSelectedTest.id = data.testId;
    updatedSelectedTest.testId = data.testId;
    
    updatedSelectedTest.mappedTestName =  this.props.mappedTest || data.mappedTestName;
    updatedSelectedTest.scheduleID=data.scheduleID||'';
    
    let updatedMappedTestName
    if(updatedIsTestMapped)
      {
          updatedMappedTestName = updatedSelectedTest.mappedTestName
      }
      
    
    
    const formErrors= this.resetFormErrors();
    this.setState(
      {
        selectedTest: updatedSelectedTest,
        isTestMapped: updatedIsTestMapped,
        mappedTestName: updatedMappedTestName,
        formErrors
      },
      () => this.canActivateCTA()
    );
    
  };

  resetSelectedTest = () => {
    let updatedSelectedTest = { ...this.state.selectedTest };
    updatedSelectedTest.testType = '';
    updatedSelectedTest.duration = '';
    updatedSelectedTest.status = '';
    updatedSelectedTest.codeName = '';
    updatedSelectedTest.displayName = '';
    updatedSelectedTest.scheduleID =  _.get(this.state,"selectedTest.scheduleID",''),
    updatedSelectedTest.scheduleDate = '';
    updatedSelectedTest.startTime = '';
    updatedSelectedTest.scheduleEndDate = '';
    updatedSelectedTest.endTime = '';
    updatedSelectedTest.maxAttempt = '';
    updatedSelectedTest.questionsCount = 0;
    updatedSelectedTest.blockRevisionTime = '';
    updatedSelectedTest.id = '';

    let updatedPaperDetail = { ...this.state.selectedTest.paperDetail };
    let updatedSyllabus = { ...this.state.selectedTest.syllabus };
    updatedSyllabus.text = '';
    updatedPaperDetail.id = '';
    updatedPaperDetail.name = '';
    updatedPaperDetail.type = '';
    updatedPaperDetail.syllabus = updatedSyllabus;

    updatedSelectedTest.paperDetail = updatedPaperDetail;
    updatedSelectedTest.mappedTestName = '';
    this.setState({
      selectedTest: updatedSelectedTest,
      isTestMapped: false
    }, () => this.resetFormErrors() );
  };

  resetFormErrors = (selectedTest?: any) => {
    let updatedFormErrors = { ...this.state.formErrors };
    const { treeData } = this.props;
    const { phases } = treeData;
    
    const isTestAlreadyInCoursePlan = selectedTest ? checkIfTestIdAlreadyMappedInPlan(phases, selectedTest.paperDetail.id) : false;

    updatedFormErrors.duration = selectedTest ? this.validateData('duration', selectedTest.duration) : '';
    updatedFormErrors.displayName = selectedTest ? this.validateData('displayName', selectedTest.displayName) : '';
    updatedFormErrors.scheduleDate = selectedTest ? this.validateData('scheduleDate', selectedTest.scheduleDate) : '';
    updatedFormErrors.maxAttempt = selectedTest ? this.validateData('maxAttempt', selectedTest.maxAttempt) : '';
    updatedFormErrors.questionsCount = selectedTest ? this.validateData('questionsCount', selectedTest.questionsCount) : '';
    
    updatedFormErrors.blockRevisionTime = selectedTest
      ? this.validateData('blockRevisionTime', selectedTest.blockRevisionTime)
      : '';

    let updatedPaperDetailFormError = { ...updatedFormErrors.paperDetail };
    let updatedSyllabusFormError = { ...updatedFormErrors.paperDetail.syllabus };

    updatedSyllabusFormError.text = selectedTest
      ? this.validateData('syllabus', selectedTest.paperDetail.syllabus.text)
      : '';
    updatedPaperDetailFormError.syllabus = updatedSyllabusFormError;
    updatedFormErrors.paperDetail = updatedPaperDetailFormError;
     if(isTestAlreadyInCoursePlan){
      updatedFormErrors.mappedTestValid ='This test already exists in the goal';
    } else {
      updatedFormErrors.mappedTestValid = ''
    }

    return updatedFormErrors;
  };

  getDateAndTime = (date: string) => {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const receivedDate = new Date(date);

    const day = receivedDate.getDate();
    const month = months[receivedDate.getMonth()];
    const year = receivedDate.getFullYear();

    const onlyDate = `${year}-${month}-${day}`;
  };

  componentDidUpdate(props: AddTestDialogProps) {
    if (props.existingScheduledTests !== this.props.existingScheduledTests) {
      this.setState(
        {
          scheduledTests: this.props.existingScheduledTests,
        },
        () => this.setScheduledTestsNames(this.props.existingScheduledTests || [])
      );
    }

    if (props.mapTestSuggestions !== this.props.mapTestSuggestions) {
      this.setState(
        {
          mapTestSuggestions: this.props.mapTestSuggestions,
        },
        () => this.setMapTestSuggestionNames(this.props.mapTestSuggestions)
      );
    }

    if (props.coursesByScheduleId !== this.props.coursesByScheduleId) {
      this.setState(
        {
          coursesByScheduleId: this.props.coursesByScheduleId,
        },
        () => this.prepareCoursesForEditTestDialog(this.props.coursesByScheduleId)
      );
    }

    if (props.editMode !== this.props.editMode) {
      if (this.props.editMode) {
        this.setState(
          {
            editMode: true,
          },
          () => this.setFormData(this.props.test)
        );
      }
    }
  }

  prepareCoursesForEditTestDialog = (courseRawData: any[]) => {
    let preparedCourseData: any[] = [];
    // Create array of CourseInfo object
    this.setState({
      preparedCourseData,
    });
  };

  setScheduledTestsNames = (testData: ExistingScheduledTest[]) => {
    const scheduledTestsNames = testData.map((test) => ({
      displayName: test.displayName,
      id: test._id,
    }));
     this.setState(
      {
        scheduledTestsNames: scheduledTestsNames,
      },
    );
  };

  setMapTestSuggestionNames = (data: any[]) => {
   const suggestionNames =
      data &&
      data.map((obj) => ({
        title: obj.title,
        id: obj.content_Id,
        contentId: obj.contentId
      }));

      if(data.length === 0) {
        suggestionNames.unshift({
          title: 'None',
          id: -1,
          contentId: null
        })
      }
      
      this.setState(
      {
        mapTestSuggestionNames: suggestionNames,
      },
     );
    
  };

  handleToggleOpen = () => {
    this.setState((previousState: any) => ({
      open: !previousState.open,
    }));
  };

  handleToggleRadiio = () => {
    this.resetSelectedTest();
    // this.resetFormErrors();
    this.setState((previousState: any) => ({
      existingTest: !previousState.existingTest,
      scheduledTest: !previousState.scheduledTest,
      check: !previousState.check,
    }));
  };

  handleTextField = (textFieldStringArray: any) => {
    const { classes, isPreview } = this.props;
    return (
      textFieldStringArray.length &&
      textFieldStringArray.map((item: { title: string; name: string; value: string; classes: string }) => (
        <>
          <Typography className={classes.inputLable}>
            {item.title}
            <span className={classes.colorRed}>*</span>
          </Typography>
          <Grid className={classes.customTextField}>
            <MyPATTextField
              id='outlined-bare'
              fullWidth={true}
              margin='normal'
              variant='outlined'
              name={item.name}
              value={
                item.value !== 'paperDetail.syllabus.text'
                  ? this.state.selectedTest[`${item.value}`]
                  : (
                      this.state.selectedTest.paperDetail.syllabus.text &&
                      this.state.selectedTest.paperDetail.syllabus.text.replace(/(<([^>]+)>)/ig, '')
                    )
              } // this.state.selectedTest in string
              onChange={(e: any) => this.handleChange(e)}
              error={
                item.value !== 'paperDetail.syllabus.text'
                  ? this.state.formErrors[`${item.value}`] !== ''
                    ? true
                    : false
                  : this.state.formErrors.paperDetail.syllabus.text !== ''
                    ? true
                    : false
              }
              errorText={
                item.value !== 'paperDetail.syllabus.text'
                  ? this.state.formErrors[`${item.value}`]
                  : this.state.formErrors.paperDetail.syllabus.text
              }
              disabled={isPreview}
            />
          </Grid>
        </>
      ))
    );
  };

  handleDropDown = (dropDownStringArray: any) => {
    const { classes } = this.props;
    return (
      dropDownStringArray.length &&
      dropDownStringArray.map((item: String) => (
        <>
          <Typography className={classes.inputLable}>{item}</Typography>
          <TextField id='outlined-bare' select fullWidth={true} margin='normal' variant='outlined' />
        </>
      ))
    );
  };

  handleDuration = (durationAttemptRevision: any) => {
    const { classes } = this.props;
    const { isTestMapped } = this.state;
    const { testType, isExtraTests } = this.props;
    const isMaxAttemptRequired = testType !== 'week' && !isExtraTests;

    return (
      durationAttemptRevision.length &&
      durationAttemptRevision.map((item: { title: string; name: string; value: string; placeholder?: string; }) => (
        <Grid item xs={item.value === 'duration' || item.value === 'maxAttempt' ? 6 : 6}>
          <Typography className={classes.inputLable}>
            {item.title}
            { (item.value !== 'maxAttempt' || isMaxAttemptRequired) && item.name != 'blockRevisionTime'?<span className={classes.colorRed}>*</span>:<span></span>}
          </Typography>
          <div className={classes.customTextField}>
            <MyPATTextField
              id='outlined-bare'
              fullWidth={true}
              margin='normal'
              variant='outlined'
              name={item.name}
              disabled={
                        (
                          (item.value === 'duration' && isTestMapped) || 
                          (item.value === "questionsCount" && isTestMapped && +this.state.selectedTest[`${item.value}`] > 0) || 
                          (item.value === "duration" && this.state.selectedTest.mappedTestName && this.state.selectedTest.mappedTestName.length > 0) ||
                          (item.value === "questionsCount" && this.state.selectedTest.mappedTestName && this.state.selectedTest.mappedTestName.length > 0)
                        )
                      }
              value={this.state.selectedTest[`${item.value}`]}
              onChange={(e: any) => this.handleChange(e)}
              error={this.state.formErrors[`${item.value}`] !== '' ? true : false}
              errorText={this.state.formErrors[`${item.value}`]}
              onKeyPress={onlyAllowNumbers}
              placeholder={item.placeholder}
              endAdornment={item.name === 'blockRevisionTime' && (
                <InputAdornment position="end">
                  <Typography variant="subheading" style={{ color: '#999', paddingRight: '10px' }}>
                    (in Days)
                  </Typography>
                </InputAdornment>
              )}
            />
          </div>
        </Grid>
      ))
    );
  };

  handleDateChange = (date: any, type: string) => {
    const updatedSelectedTest = { ...this.state.selectedTest };
    let updatedFormErrors = { ...this.state.formErrors };
    switch (type) {
      case 'startDate':
        updatedSelectedTest.scheduleDate = new Date(date).toString();
        updatedFormErrors.scheduleDate = '';
        const endDate = new Date(date);
        endDate.setHours(endDate.getHours() + 3);
        updatedSelectedTest.scheduleEndDate = endDate.toString();
        updatedFormErrors.scheduleEndDate = '';
        break;
      case 'endDate':
        updatedSelectedTest.scheduleEndDate = new Date(date).toString();
        updatedFormErrors.scheduleEndDate = '';
        break;
      default:
        break;
    }
    this.setState({
      selectedTest: updatedSelectedTest,
      formErrors: updatedFormErrors,
    }, () => this.canActivateCTA());
  };

  removeEndDate(type: string) {
    if (type === 'End Date & Time') {
    const updatedSelectedTest = { ...this.state.selectedTest };
    let updatedFormErrors = { ...this.state.formErrors };
    updatedSelectedTest.scheduleEndDate = '';
    updatedFormErrors.scheduleEndDate = '';
    this.setState({selectedTest: updatedSelectedTest, formErrors: updatedFormErrors});
    }
  }





  handleTimeChange = (time: any, type: string) => {
    const updatedcurrentTestDetail = { ...this.state.selectedTest };
    const newTime = new Date(time);
    const hours = newTime.getHours();
    const minutes = newTime.getMinutes();
    const seconds = newTime.getSeconds();
    const milliseconds = newTime.getMilliseconds();
    let { scheduleDate, scheduleEndDate } = updatedcurrentTestDetail;
    // const minStartDate=_.get(this.props,"basicDetail.startDate.value");
    // const minEndDate=_.get(this.props,"basicDetail.endDate.value");

    switch (type) {
      case 'startTime':
        if (!scheduleDate) {
          scheduleDate = new Date();
        }
        let tempDate = new Date(scheduleDate);
        tempDate.setHours(hours, minutes, seconds, milliseconds);
        updatedcurrentTestDetail.scheduleDate = tempDate.toISOString();
        break;
      case 'endTime':
        if (!scheduleEndDate) {
          scheduleEndDate = new Date();
        }
        tempDate = new Date(scheduleEndDate);
        tempDate.setHours(hours, minutes, seconds, milliseconds);
        updatedcurrentTestDetail.scheduleEndDate = tempDate.toISOString();
        break;
      default:
    }

    this.setState({
      selectedTest: updatedcurrentTestDetail,
    }, () => this.canActivateCTA());
  };

  getTestMinDate = () => {
    const { packageStartDate, phases, phaseIndex, phase, isExtraTests } = this.props;
    let date;
    if(!isExtraTests) {
      date =  new Date(phase.startDate);
        } else {
      date = phase.startDate;
      date =  new Date(date);
    }
    date.setHours(0,0,0);
    return date;
  }

  getTestMaxDate = () => {
    const { packageEndDate, phases, phase,  phaseIndex, isExtraTests, testType } = this.props;
    let date;
    if(!isExtraTests && testType === 'week') {
      date =  new Date(phase.endDate);
     } else {
      if(phaseIndex === (phases.length - 1)){
        date = packageEndDate
      } else {
        const nextPhase = phases[phaseIndex + 1];
        date = nextPhase.startDate
        date = new Date(date)
        date.setDate(date.getDate() - 1)
      }
      date = new Date(date)
    }

    date.setHours(23,59,59);
    return date;
  }
  

  handleStartEndDate = () => {
    const { classes, isPreview, phases, phase, phaseIndex, packageStartDate, packageEndDate, testType } = this.props;
    const { scheduleDate: startDate, scheduleEndDate: endDate } = this.state.selectedTest;
    const testMinDate = this.getTestMinDate();
    const testMaxDate = this.getTestMaxDate();
    

    const startDateVal = startDate ? new Date(startDate) : null
    const endDateVal = endDate ? new Date(endDate) : ''

    const isSelectedTestStartDateCorrect = startDate >= testMinDate;
    const isSelectedTestEndDateCorrect = endDate <= testMaxDate;
    const DateVals = [
      {
        label: 'Start Date & Time',
        dateKey: 'startDate',
        timeKey: 'startTime',
      },
      {
        label: 'End Date & Time',
        dateKey: 'endDate',
        timeKey: 'endTime',
      },
    ];
    const {displayName} = this.state.selectedTest

    return (
      DateVals.length &&
      DateVals.map((item: { label: string; dateKey: string; timeKey: string }) => (
        <>
          <Grid container justify='space-between' spacing={16}>
            <Grid item xs={6}>
              <InputLabel className={classes.inputLable}>{item.label}</InputLabel>
              {item.label === 'Start Date & Time' && <span className={classes.colorRed}>*</span>}
              {item.label === 'End Date & Time' && <button className={classes.removeEndDate} disabled={endDateVal === ''} onClick={() => {this.removeEndDate(item.label)}}>Remove</button>}
              <MyPATCalendar
                fullWidthControl
                onChange={(dateVal: string) => this.handleDateChange(dateVal, item.dateKey)}
                date={
                  item.label === 'Start Date & Time'
                    ? (startDateVal)
                    : (endDateVal)
                }
                placeholder={item.label === 'Start Date & Time' ? 'Select Start Date' : 'Select End Date'}
                initiallyTouched = {testType === 'week' && item.dateKey === 'endDate' ? false : true }
                minDate={
                  item.label === 'Start Date & Time' ? 
                    (displayName !== '' ? testMinDate : testMinDate) 
                    : 
                    (displayName !== '' ? (startDate ? startDate : testMinDate) : testMinDate)
                }
                maxDate = {
                  item.label === 'Start Date & Time' ? 
                  testMaxDate 
                  : 
                  testMaxDate
                }
                disabled={ 
                  item.label === 'End Date & Time'
                    ? this.state.selectedTest.scheduleDate === ''
                      ? true
                      : false
                    : false
                }
                errorText={ 
                              this.state.selectedTest.scheduleDate !== '' ? 
                              (item.label === 'Start Date & Time' ? 'Date should be within course plan.' : '') :
                              (item.label === 'Start Date & Time' ? 'Start date is required.' : 'End date is required.')
                            }
              />
            </Grid>
            <Grid item xs={6}>
              <InputLabel className={classes.inputLable}></InputLabel>
              <div className={classes.customTime}>
                <TimeInput
                  disableUnderline={true}
                  mode='12h'
                  value={item.label === 'Start Date & Time' ? (startDate ? new Date(startDate) : new Date()) :
                    (endDate ? new Date(endDate) : null)}
                  onChange={(time: any) => this.handleTimeChange(time, item.timeKey)}
                  disable={true}
                   //defaultValue={new Date()}
                  placeholder={
                      item.label === 'Start Date & Time'
                        ? (startDate ? null : 'Select Start Time')
                        : (endDate ? null : 'Select End Time')
                  }
                  disabled={item.label === 'End Date & Time' && endDateVal === ''}
                />
              </div>
            </Grid>
          </Grid>
        </>
      ))
    );
  };

  handleRadioButton = () => {
    const { existingTest, scheduledTest } = this.state;
    const { classes } = this.props;
    const radio1 = 'Add Existing Scheduled Test';
    const radio2 = 'Schedule A New Test';
    return (
      <div className={classes.root}>
        {/* @frontend please use this */}
        <FormControl component='fieldset'>
          <RadioGroup
            classes={{
              root: classes.testRadioGroup,
            }}
          >
            <FormControlLabel
              control={
                <Radio
                  color='primary'
                  checked={existingTest}
                  onChange={this.handleToggleRadiio}
                  value='e'
                  name='radio-button-demo'
                />
              }
              label='Map Existing Schedule/ Test'
            />
            <FormControlLabel
              control={
                <Radio
                  color='primary'
                  checked={scheduledTest}
                  onChange={this.handleToggleRadiio}
                  value='e'
                  name='radio-button-demo'
                />
              }
              // aria-label='E'
              label='Add New Schedule/Test'
            />
          </RadioGroup>
        </FormControl>
        {/* End */}
          </div>
    );
  };

  renderSelectGoalOptions = () => {
    let options = [];
    options.push(<option value={''}>{'Select Test'}</option>);
    _.map(this.state.scheduledTestsNames, ({ displayName, id }) =>
      options.push(
        <option key={id} value={id}>
          {displayName}
        </option>
      )
    );
    return options;
  };

  handleChange = async (e: any, data?: any) => {
    const { name, value } = e.target;
    //console.log(name, value);
    const { selectedTest } = this.state;
    let updatedSelectedTest = { ...selectedTest };

    const { formErrors } = this.state;
    let updatedFormErrors = { ...formErrors };

    let result;
    switch (name) {
      case 'selectedTest':
        const selectedTestObject = { ...this.props.existingScheduledTests.filter((test) => test._id === value)[0] };
        this.resetSelectedTest();

        const {questionsCount, duration,contentId} = await this.getTestDetailById(selectedTestObject.paperDetail.id);
        const updatedFormErrorsAfterTestSelection:any = this.resetFormErrors({...selectedTestObject, questionsCount, duration});
        this.props.fetchCoursesByScheduleId(selectedTestObject.scheduleID);
         if(contentId){
           const propsCourseId=_.get(this.props,"packageByIdData.packageData.courseDetails[0].courseId",'');
           const apiError= await this.checkIfTestExistInGoal(selectedTest.contentId,propsCourseId);
           if(apiError){
            updatedFormErrorsAfterTestSelection.mappedTestValid=apiError;
           }
         }
        updatedIsTestMapped = selectedTestObject.paperDetail.id === '000000000000000000000000' ? false : true;
        let updatedPaperDetail = { ...selectedTestObject.paperDetail };
        updatedSelectedTest.displayName = selectedTestObject.displayName;

        updatedPaperDetail.syllabus = selectedTestObject.paperDetail.syllabus;
        updatedSelectedTest.paperDetail = updatedPaperDetail;

        updatedSelectedTest.duration = duration;
        updatedSelectedTest.maxAttempt = selectedTestObject.maxAttempt;
        updatedSelectedTest.questionsCount = questionsCount;
        updatedSelectedTest.scheduleDate = selectedTestObject.scheduleDate;
        updatedSelectedTest.scheduleEndDate = selectedTestObject.scheduleEndDate;
        updatedSelectedTest.status = selectedTestObject.status;
        updatedSelectedTest.id = selectedTestObject._id;
        updatedSelectedTest.testId = selectedTestObject.paperDetail.id;

         this.setState(
          {
            selectedTest: updatedSelectedTest,
            isTestMapped: updatedIsTestMapped,
            formErrors: updatedFormErrorsAfterTestSelection,
          });
        
        break;
      case 'testName':
        updatedSelectedTest.displayName = value;
        updatedSelectedTest.paperDetail.name=value;
        result = this.validateData('displayName', value);
        updatedFormErrors.displayName = result;
        this.setState(
          {
            selectedTest: updatedSelectedTest,
            formErrors: updatedFormErrors,
          },
          () => {
            this.canActivateCTA();
          }
        );
        break;
      case 'testSyllabus':
        let newPaperDetail = { ...updatedSelectedTest.paperDetail };
        let updatedSyllabusFormData = { ...updatedSelectedTest.paperDetail.syllabus };
        updatedSyllabusFormData.text = value;
        newPaperDetail.syllabus = updatedSyllabusFormData;
        updatedSelectedTest.paperDetail = newPaperDetail;
        result = this.validateData('syllabus', value);

        let updatedPaperDetailCopy = { ...updatedFormErrors.paperDetail };
        let updatedSyllabus = { ...updatedFormErrors.paperDetail.syllabus };
        updatedSyllabus.text = result;
        updatedPaperDetailCopy.syllabus = updatedSyllabus;
        updatedFormErrors.paperDetail = updatedPaperDetailCopy;

        this.setState(
          {
            selectedTest: updatedSelectedTest,
            formErrors: updatedFormErrors,
          },
          () => {
            this.canActivateCTA();
          }
        );
        break;
      case 'duration':
        updatedSelectedTest.duration = value;
        result = this.validateData('duration', value);
        updatedFormErrors.duration = result;

        this.setState(
          {
            selectedTest: updatedSelectedTest,
            formErrors: updatedFormErrors,
          },
          () => {
             this.canActivateCTA();
          }
        );
        break;
      case 'blockRevisionTime':
        updatedSelectedTest.blockRevisionTime = value;
       // result = this.validateData('blockRevisionTime', value);
        //updatedFormErrors.blockRevisionTime = result;

        this.setState(
          {
            selectedTest: updatedSelectedTest,
            formErrors: updatedFormErrors,
          },
          () => {
            this.canActivateCTA();
          }
        );
        break;
      case 'maxAttempt':
        updatedSelectedTest.maxAttempt = value;
        
        result = this.validateData('maxAttempt', +value);
        updatedFormErrors.maxAttempt = result;

        this.setState(
          {
            selectedTest: updatedSelectedTest,
            formErrors: updatedFormErrors,
          },
          () => {
            this.canActivateCTA();
          }
        );
        break;

      case 'questionsCount':
        updatedSelectedTest.questionsCount = +value;
        result = this.validateData('questionsCount', +value);
        updatedFormErrors.questionsCount = result;

        this.setState({
          selectedTest: updatedSelectedTest,
          formErrors: updatedFormErrors
        }, 
        () => {
          this.canActivateCTA();
        });
        break;
      default:
    }
  };
  checkIfTestExistInGoal=async (contentId:string,courseId:string)=>{
    const source="mapTestInCourse";
    const err= await courseManagementServices.validateMapTestIdBySource({contentId,courseId,source});  
    return err;
  }
  handleTestMapping = async (course: any) => {
    if(course.id === -1) return;
    let updatedFormErrors = { ...this.state.formErrors };
    const { selectedTest } = this.state;
    const { treeData, mapTestSuggestions } = this.props;
    const { phases } = treeData;
    const updatedSelectedTest = {...selectedTest};
    if(course.id === -1){
      // For the case when null is selected
      return this.resetMapTestToInitial()
    }

    updatedSelectedTest.mappedTestName = course.title;
    // updatedSelectedTest.testId=course.id;
    // updatedSelectedTest.id=course.id;
    // @Rittick Datta you not save testId on selecting the test
    updatedSelectedTest.paperDetail.id = course.id;
    updatedSelectedTest.testId=course.id;
    updatedSelectedTest.contentId = course.contentId;
    
    const { questionsCount, duration,contentId } = await this.getTestDetailById(updatedSelectedTest.testId);
    
    updatedSelectedTest.questionsCount = questionsCount;
    updatedSelectedTest.duration = duration;

    const propsCourseId=_.get(this.props,"packageByIdData.packageData.courseDetails[0].courseId",'');
    const apiError= await this.checkIfTestExistInGoal(contentId,propsCourseId);
    const isTestAlreadyInCoursePlan = checkIfTestIdAlreadyMappedInPlan(phases, course.id);

    if(isTestAlreadyInCoursePlan||apiError){
      updatedFormErrors.mappedTestValid = apiError?apiError:'This test already exists in the course';
    } else {
      updatedFormErrors.mappedTestValid = ''
    }
    this.setState({
      selectedTest: updatedSelectedTest,
      formErrors: updatedFormErrors,
    })
    this.canActivateCTA();
  };

  setFormErrorsForMappingTest = (errors: string) => {
    // TODO
    let showErrorsFor:any = [];
    const validErrors = [
      "Start Date missing",
      "Invalid startDate",
      "End Date missing",
      "Missing test name",
      "Question Count Missing.",
      "Duration does not match"]
    const receivedErrors = errors.split(',');
    receivedErrors.forEach((error) => {
      const searchResult = validErrors.find((err:string) => err === error)
      if(searchResult) {
        showErrorsFor.push(searchResult)
      }
    })
   
    const { formErrors } = this.state;
    let updatedFormErrors = {...formErrors}

    showErrorsFor.forEach((err: string) => {
      if(err.toString().includes('Start Date missing')) {updatedFormErrors.scheduleDate = 'Start date is required.' }
      if(err.toString().includes('Invalid startDate')) {updatedFormErrors.scheduleDate = 'Start date is required.' }
      if(err.toString().includes('End Date missing')) {updatedFormErrors.scheduleEndDate = 'End date is required.'}
      if(err.toString().includes('Missing test name')) {updatedFormErrors.displayName = 'Test name is required.'}
      if(err.toString().includes('Question Count Missing.')) {updatedFormErrors.questionsCount = 'Question count is required.' }
      if(err.toString().includes('Duration does not match')) {updatedFormErrors.duration = 'Duration is required.'}
    })
    
    

    this.setState({
      formErrors: updatedFormErrors
    })
  }

  getSearchResult = (searchQuery: string) => {
    const { formErrors, goalsDriller } = this.state;
    const { testType, test } = this.props;
    let mainTestTypes=['full','part','combined'];
    let contentSubTypeCode = 'phase';
    if( testType === 'week'){
       if(!mainTestTypes.includes(test.type)){
          mainTestTypes.push(test.type);
       }
      contentSubTypeCode=mainTestTypes.join(',');
    }
     let updatedFormErrors = {...formErrors}
    if(searchQuery === ''){
      updatedFormErrors.mappedTestValid = ''
      this.resetMapTestToInitial()
    }
    if (searchQuery) {

      const payload = {
        searchText: searchQuery,
        goalsDriller: {...goalsDriller},
        testType: contentSubTypeCode
      }
      
      setTimeout(() => this.props.fetchMapTestSuggestions(payload), 1000);
  }

  

    this.setState({
      formErrors: updatedFormErrors,
    }, () => {
     this.canActivateCTA();
    })
  };

  setGoalsDriller = async (courseId: string) => {
    if(courseId !== ''){
      const res = await courseManagementServices.getCourseDetails(courseId);
      const { courseType, id, groupId, name, targetYear, _id } = res;
      if (res && Object.keys(res).length) {
        const goals = {
          level: 'course',
          course: { courseType, id, groupId, name, targetYear, _id },
        };
        this.setState({
          goalsDriller: {
            ...goals,
          }
        })
      }

    }
  }

  resetMapTestToInitial = () => {
    const { selectedTest } = this.state;
    const updatedSelectedTest = {...selectedTest};
    updatedSelectedTest.mappedTestName = '';
    updatedSelectedTest.paperDetail.id='';
    this.setState({
      selectedTest: updatedSelectedTest
    })
  }

  handleCTAClick = () => {
    const {selectedTest}=this.state;
    const updatedTest={...selectedTest};
    if(!(updatedTest.courseId)){ 
       const courseId=_.get(selectedTest,"courseId",this.props.courseId);
       updatedTest.courseId=courseId;
       this.setState({selectedTest:updatedTest});
    }
    this.props.handleAddTest && this.props.handleAddTest(updatedTest);
    this.props.handleToggleOpen();
  };

  validateData = (field: any, value: any) => {
    const { testType, isExtraTests } = this.props;
    const isMaxAttemptRequired = testType !== 'week' && !isExtraTests;
    
    switch (field) {
      case 'displayName':
        return value ? (value.length === 0 ? 'Test name is required' : '') : 'Test name is required';
      case 'syllabus':
        return value ? (value.length === 0 ? 'Syllabus is required' : '') : 'Syllabus is required';
      case 'duration':
        return value ? (value.length === 0 ? 'Duration is required' : '') : 'Duration is required';
      case 'maxAttempt':
        return isMaxAttemptRequired ? (
                  value ? 
                  (value.length === 0 ? 'Max attempt is required' : '') : 
                    (value === undefined ? (this.state.selectedTest.maxAttempt === '' ? 
                    'Max attempt is required' : 
                    '') 
                    : 'Max attempt is required')) : '';
      case 'questionsCount':
        return value ? (((+value > 0) && (+value <=500)) ? '' : 'Question count can be from 1 to 500') : 'Question count is required' 
      case 'scheduleDate':
      case 'scheduleEndDate':
      case 'startTime':
      case 'endTime':
      default:
        return '';
    }
  };

  canActivateCTA = () => {
    const { formErrors, selectedTest } = this.state;
    const { isExtraTests, testType } = this.props;
    const isMaxAttemptAndDateRequries = testType !== 'week' && !isExtraTests;
    let disableCTABtn = true;
  
    if (
      formErrors.displayName === '' &&
      selectedTest.displayName.length > 0 &&
      formErrors.paperDetail.syllabus.text === '' &&
      selectedTest.paperDetail.syllabus.text.length > 0 &&
      formErrors.duration === '' &&
      (+selectedTest.duration) && (+selectedTest.duration) > 0 &&
      (
        !isMaxAttemptAndDateRequries || (formErrors.maxAttempt === '' &&
         (+selectedTest.maxAttempt) && (+selectedTest.maxAttempt) > 0)
      ) &&
      formErrors.scheduleDate === '' &&
      (selectedTest.scheduleDate && selectedTest.scheduleDate.toString().length > 0) &&
      formErrors.questionsCount === '' &&
      selectedTest.questionsCount > 0 &&
      formErrors.startTime === '' &&
      formErrors.scheduleEndDate === '' &&
      formErrors.endTime === '' &&
      formErrors.mappedTestValid === ''
    )
      disableCTABtn = false;

    this.setState(
      {
        isCTADisabled: disableCTABtn,
      },
    );
  };

  getTestDetailById = async (testId: string) => {
    const res = await contentService.details(`${testId}testpapers`);
    const { title, contentId, content: { data : { questionsCount = 0 } = {} }= {} , duration = 0} = res;
    this.setState({
      mappedTestName: `${contentId}| ${title}`
    })
    return {questionsCount, duration,contentId};
  };

  validateTestIds = async (tests: Array<any>, courseId: string) => {
    const { packageByIdData } = this.props;
    const { packageData } = packageByIdData;
    const { _id: packageId } = packageData;
    const reqParams = {
      tests: tests,
      courseId: courseId,
      packageId: packageId,
      testType: 'phase'
    };
    try {
      const res = await courseManagementServices.validateTestIds(reqParams);
      return res;
    } catch (err) { }
  };

  render() {
    const { check } = this.state;
    const { open } = this.props;
    const {
      title,
      dropDownStringArray,
      textFieldStringArray,
      dialogButtonName,
      isExistingTest,
      durationAttemptRevision,
      buttonName,
      isRequiredMapTest,
      isExistingAndScheduledTest,
      isRequiredDate,
      classes,
    } = this.props;


    
    return (
      <div>
       <MyPATDialog
          isApplyCustom
          isfixedDialogActions
          dialogOpen={open}
          dialogHasActions={true}
          dialogHeading={title}
          isAlignCenter={true}
          customButtonVariant='withoutBorderCloseIcon'
          onDialogClose={() => this.props.handleToggleOpen && this.props.handleToggleOpen()}
          isCustomBackground={false}
          isborderDialogAction={true}
          otherDialogProps={{
            fullWidth: true,
            // maxWidth: 'sm',
          }}
          className='dialogBox'
          customDialogActions={
            <>
              <Grid container justify='flex-end' className={classes.mt15}>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.button}
                  onClick={this.handleCTAClick}
                  disabled={this.state.isCTADisabled}
                >
                  {dialogButtonName}
                </Button>
              </Grid>
            </>
          }
        >
          <div style={{ marginTop: '-10px' }}>
            {isExistingAndScheduledTest && this.handleRadioButton()}
            {!check && isExistingTest && (
              <>
                <Grid className={classes.customSelect}>
                  <Typography className={classes.inputLable}>Select Existing Scheduled Test</Typography>
                
                  <MyPATSelect
                    value={this.state.selectedTest.id || ''}
                    name='selectedTest'
                    onChange={(e: any) => this.handleChange(e)}
                  >
                    {this.renderSelectGoalOptions()}
                  </MyPATSelect>
                </Grid>
              </>
            )}
            {this.handleTextField(textFieldStringArray)}
            <div>{isRequiredDate && this.handleStartEndDate()}</div>
            <div>
              <Grid className={[classes.manageField, classes.customGrid].join(' ')}>
                {this.handleDuration(durationAttemptRevision)
                }</Grid>
                
            </div>
            {isRequiredMapTest && (
              <>
                <Typography className={classes.inputLable}>
                  Map Test <span> (Optional, can be done later)</span>
                </Typography>
                {this.state.isTestMapped && (
                  <Grid className={classes.dialogSelect} >
                    <MyPATTextField
                    id='outlined-bare'
                    fullWidthInput={true}
                    margin='normal'
                    variant='outlined'
                    value={this.state.mappedTestName}
                    disabled={this.state.isTestMapped}
                    startAdornment={
                      <InputAdornment position="start" style={{marginRight: '0'}}>
                        <img style={{paddingLeft: '10px'}} src={'/assets/svg/test-icon.svg'} alt="Test Icon" />
                      </InputAdornment>
                    }
                    error={this.state.formErrors.mappedTestValid.length > 0}
                    errorText={this.state.formErrors.mappedTestValid}
                  />
                  </Grid>
                )}
                {!this.state.isTestMapped && (
                  <Grid className={classes.transitionCSS}>
                    <Grid className="searchTransition">
                      <MyPATMultiSearch
                        options={this.state.mapTestSuggestionNames}
                        labelKey='title'
                        valueKey='id'
                        onChange={this.handleTestMapping}
                        // values={this.state.selectedTest.paperDetail.id}
                        isSearchAble
                        isCustomFilter
                        filtredFunction={this.getSearchResult}
                        // name="creator"
                        placeholderText='Enter Test Name/ ID to be mapped'
                        error={this.state.formErrors.mappedTestValid !== ''}
                        errorText={this.state.formErrors.mappedTestValid}
                      />
                    </Grid>
                  </Grid>
                )}
              </>
            )}
           
          </div>
        </MyPATDialog>
      </div>
    );
  }
}
// @ts-ignore
// export default withStyles(styles)(AddTestDialog);

const mapStateToProps = (state: any) => ({
  existingScheduledTests: state.courseMangementData.courseManagementReducer.scheduledTests,
  mapTestSuggestions: state.courseMangementData.courseManagementReducer.mapTestSuggestions,
  coursesByScheduleId: state.courseMangementData.courseManagementReducer.coursesByScheduleId,
  treeData: _.get(state, 'courseMangementData.contentManagementData.treeData', {}),
  packageByIdData: _.get(state, 'courseMangementData.contentManagementData.packageByIdData', {}),
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      fetchExistingScheduledTests: courseManagementActions.fetchExistingScheduledTests,
      fetchMapTestSuggestions: courseManagementActions.fetchMapTestSuggestions,
      fetchCoursesByScheduleId: courseManagementActions.fetchCoursesByScheduleID,
      fetchScheduleTests: courseManagementActions.fetchScheduleTests,
    },
    dispatch
  );

// @ts-ignore
export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(courseStyles)(withRouter(AddTestDialogPopUp)));